<div class="holder">
  @if (activeTestRun) {
    <div>
      <div class="add-to-finding-heading">
        Add Test Mail to Finding
      </div>
      <wm-add-to-finding type="screenshot" [addedToFinding]="addedToFinding" (findingSelected)="addToFinding($event)"></wm-add-to-finding>
    </div>
  } @else {
    No Active Test Run.
  }
</div>

